import React, { useEffect, useState, useRef } from "react";
import ReactDOM from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import { AiOutlineClose } from "react-icons/ai";
import { toast } from "react-toastify";
import {
  readGalleryRequest,
  saveGalleryRequest,
} from "../../store/Gallery/galleryAction";
import LensSearch from "../../assets/icons/LensSearch.svg";
import DropdownField from "../InputFields/DropDown";
import { setActiveLanguage } from "../../store/Dashboard/DashboardAction";
import UploadControlsV2 from "../TWG/UploadControlsV2";
import close from "../../assets/icons/close.svg";
import {
  uploadAssestsV2Action,
  uploadVideosV2Action,
} from "../../store/Languages/LanguageAction";

const GalleryLibraryModal = ({ isOpen, onClose, handleGallerySelect, church, typeofentity }) => {
  const churchObjId = church._id;

  const dispatch = useDispatch();
  const { galleryList, loading } = useSelector((state) => state.gallery);
  const { languagesList, activeLanguage } = useSelector((state) => state.language);

  const [formattedGallery, setFormattedGallery] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedPreviewImage, setSelectedPreviewImage] = useState(null);
  const [activeTab, setActiveTab] = useState("desktop");
  const [previewTab, setPreviewTab] = useState("desktop"); // Separate tab for preview modal
  const [imageDimensions, setImageDimensions] = useState({ width: 0, height: 0 });
  const [multiSelectedImages, setMultiSelectedImages] = useState([]);

  // ✅ object-fit CSS options
  const [objectFit, setObjectFit] = useState({
    desktop: "cover",
    tablet: "contain",
    mobile: "fill",
  });

  const [isAdding, setIsAdding] = useState(false);
  const [tempUrl, setTempUrl] = useState("");
  const [imageName, setImageName] = useState("");
  const [refreshFlag, setRefreshFlag] = useState(false);
  // Store default state per image
  const [imageDefaultStates, setImageDefaultStates] = useState({});
  const [showPreviewModal, setShowPreviewModal] = useState(false);

  const previewImgRef = useRef(null);

  const handleSearchChange = (e) => setSearchText(e.target.value);

  useEffect(() => {
    let finalObjIdKey = "churchObjId";
    let finalObjIdValue = churchObjId;

    const currentUrl = window.location.href;

    if (typeofentity) {
      if (Number(typeofentity) === 2) {
        finalObjIdKey = "channelObjId";
        finalObjIdValue = church.channelObjId || churchObjId;
      } else if (Number(typeofentity) === 3) {
        finalObjIdKey = "ministriesObjId";
        finalObjIdValue = church.ministriesObjId || churchObjId;
      }
    } else {
      if (currentUrl.toLowerCase().includes("addchannelfield")) {
        finalObjIdKey = "channelObjId";
        finalObjIdValue = church.channelObjId || churchObjId;
      } else if (currentUrl.toLowerCase().includes("addministryfield")) {
        finalObjIdKey = "ministriesObjId";
        finalObjIdValue = church.ministriesObjId || churchObjId;
      }
    }


    if (finalObjIdValue) {
      dispatch(readGalleryRequest({ [finalObjIdKey]: finalObjIdValue }));
    }
  }, [churchObjId, refreshFlag, isOpen, typeofentity]);

  // ✅ Format gallery like Image Gallery component
  useEffect(() => {
    if (!galleryList) return;
    const formatted = galleryList.map((item) => ({
      _id: item._id,
      name: item.imageName,
      web: {
        url: item.imageUrl || "",
        title: item.imageName || "Gallery Image"
      },
      tablet: {
        url: item.imageUrlTablet || item.tabImageUrl || item.imageUrl || "",
        title: item.imageName || "Gallery Image"
      },
      mobile: {
        url: item.imageUrlMobile || item.mobileImageUrl || item.imageUrl || "",
        title: item.imageName || "Gallery Image"
      },
      raw: item,
    }));
    setFormattedGallery(formatted);

    // Initialize default states for all images
    const defaultStates = {};
    formatted.forEach(img => {
      defaultStates[img._id] = false;
    });
    setImageDefaultStates(defaultStates);
  }, [galleryList]);

  let finalObjIdKey = "churchObjId";
  let finalObjIdValue = church._id;

  if (typeofentity) {
    if (Number(typeofentity) === 2) {
      finalObjIdKey = "channelObjId";
      finalObjIdValue = church.channelObjId || church._id;
    } else if (Number(typeofentity) === 3) {
      finalObjIdKey = "ministriesObjId";
      finalObjIdValue = church.ministriesObjId || church._id;
    }
  } else {
    const currentUrl = window.location.href;

    if (currentUrl.toLowerCase().includes("addchannelfield")) {
      finalObjIdKey = "channelObjId";
      finalObjIdValue = church.channelObjId || church._id;
    } else if (currentUrl.toLowerCase().includes("addministryfield")) {
      finalObjIdKey = "ministriesObjId";
      finalObjIdValue = church.ministriesObjId || church._id;
    }
  }


  const handleSaveImage = () => {
    if (!church?._id) return toast.error("Church ID missing!");
    if (!tempUrl) return toast.error("Please upload an image!");

    const payload = {
      apiPayloadRequest: {
        [finalObjIdKey]: finalObjIdValue,
        images: [
          {
            imageName: imageName || "Gallery Image",
            url_link: tempUrl,
          },
        ],
      },
      callback: (res) => {
        if (res?.type === 1) {
          toast.success("Image added successfully!");
          setIsAdding(false);
          setTempUrl("");
          setImageName("");
          setRefreshFlag((prev) => !prev);
        } else {
          toast.error(res?.error || "Failed to add image!");
        }
      },
    };

        dispatch(saveGalleryRequest(payload.apiPayloadRequest, payload.callback));
  };
  const toggleMultiSelect = (img) => {
    setMultiSelectedImages((prev) => {
      const exists = prev.find((i) => i.id === img._id);
      if (exists) {
        return prev.filter((i) => i.id !== img._id);
      }
      return [
        ...prev,
        {
          name: img.name,
          id: img._id,
          web: img.web,
          tablet: img.tablet,
          mobile: img.mobile,
          mobilesetting: objectFit.mobile,
          tabletsetting: objectFit.tablet,
          dashboardsetting: objectFit.desktop,
          default: imageDefaultStates[img._id] || false,
          raw: img.raw,
        },
      ];
    });
  };

  const closePreviewModal = () => {
    setSelectedPreviewImage(null);
    setShowPreviewModal(false);
    setPreviewTab("desktop"); // Reset tab when closing
    setImageDimensions({ width: 0, height: 0 }); // Reset dimensions
  };

  // ✅ Handle image load to get dimensions
  const handleImageLoad = (e) => {
    const img = e.target;
    setImageDimensions({
      width: img.naturalWidth,
      height: img.naturalHeight
    });
  };

  // ✅ Calculate modal width based on image dimensions
  const getModalWidth = () => {
    const maxWidth = window.innerWidth * 0.9; // 90% of viewport width
    const maxHeight = window.innerHeight * 0.8; // 80% of viewport height

    if (imageDimensions.width === 0 || imageDimensions.height === 0) {
      return "max-w-[90vw]";
    }

    // Calculate aspect ratio
    const aspectRatio = imageDimensions.width / imageDimensions.height;

    // Calculate width based on height constraint
    const widthFromHeight = maxHeight * aspectRatio;

    // Use the smaller of the two constraints
    const finalWidth = Math.min(maxWidth, widthFromHeight);

    // Return width in pixels
    return `${Math.min(finalWidth, 1200)}px`;
  };

  const handleGalleryFileInputChange = (
    setState,
    keyName,
    file,
    type,
    uploadProgressId = null,
    downloadable = false,
    errorKeyName = ""
  ) => {
    if (!file) return;
    const formData = new FormData();
    formData.append("file", file);
    formData.append("downloadable", downloadable);

    if (type === "videos") {
      dispatch(
        uploadVideosV2Action({
          apiPayloadRequest: formData,
          uploadProgressId,
          callback: (res) => setState(res?.url),
        })
      );
    } else {
      dispatch(
        uploadAssestsV2Action({
          apiPayloadRequest: formData,
          uploadProgressId,
          callback: (res) => {
            if (res?.url) setTempUrl(res.url);
          },
        })
      );
    }
  };

  // ✅ Handle image preview click
  const handleImagePreview = (img) => {
    setSelectedPreviewImage(img);
    setPreviewTab("desktop"); // Default to desktop tab
    setShowPreviewModal(true);
  };

  // ✅ Handle default checkbox change for a specific image
  const handleDefaultChange = (imageId, checked) => {
    setImageDefaultStates(prev => ({
      ...prev,
      [imageId]: checked
    }));
  };

  // ✅ Get image URL based on current preview tab
  const getPreviewImageUrl = () => {
    if (!selectedPreviewImage) return "";

    switch(previewTab) {
      case "desktop":
        return selectedPreviewImage.web?.url || "";
      case "tablet":
        return selectedPreviewImage.tablet?.url || selectedPreviewImage.web?.url || "";
      case "mobile":
        return selectedPreviewImage.mobile?.url || selectedPreviewImage.web?.url || "";
      default:
        return selectedPreviewImage.web?.url || "";
    }
  };

  // ✅ Render preview for settings modal
  const renderPreview = (ratioClass, tab) => {
    const tabKey = tab === "desktop" ? "web" : tab;
    if (!selectedImage?.[tabKey]?.url) return null;
    return (
      <div
        className={`relative bg-black flex items-center justify-center ${ratioClass} rounded-md overflow-hidden border border-gray-600`}
        style={{ width: "auto", maxWidth: "600px" }}
      >
        <img
          src={selectedImage[tabKey].url}
          alt={selectedImage?.name}
          className={`w-auto max-w-full h-auto max-h-[50vh] object-${objectFit[tab]} transition-all duration-300`}
        />
      </div>
    );
  };

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className="fixed inset-0 z-[9999] bg-black bg-opacity-70 flex justify-center items-center min-h-[70vh]">
      <div className="bg-[#1b1b1b] w-[90%] max-w-5xl rounded-xl overflow-hidden min-h-[70vh] relative">
        {/* Header */}
        <div className="flex items-center justify-between px-10 py-4">
          <p className="text-white text-lg font-semibold">Select from library</p>

          <div className="flex flex-1 justify-center items-center gap-3">
            <div className="relative flex gap-3 px-4 py-2 font-[450] rounded-[12px] bg-[#131313] w-5/12 border border-gray-400 border-opacity-5">
              <img src={LensSearch} alt="search" />
              <input
                className="text-white placeholder-white placeholder-opacity-20 text-[15px] bg-black bg-opacity-0 w-full focus:outline-none"
                value={searchText}
                placeholder="Search"
                onChange={handleSearchChange}
              />
            </div>

            <DropdownField
              value={activeLanguage}
              options={languagesList?.map((d) => ({
                value: d?.language_code,
                shortCode: d?.language_code,
                roleName: d?.language_name,
              }))}
              labelText=""
              width="w-full mt-0"
              handleInputChange={(e) =>
                dispatch(setActiveLanguage(e.target.value))
              }
            />
          </div>
          {multiSelectedImages.length > 0 && (
  <div className="sticky bottom-0 bg-[#1b1b1b]  border-gray-700 p-4 flex justify-end gap-3">
    <span className="text-greyish text-sm self-center">
      {multiSelectedImages.length} selected
    </span>

    <button
  onClick={() => {
    handleGallerySelect(multiSelectedImages); // ✅ send array
    setMultiSelectedImages([]);
    onClose();
  }}
  className="bg-yellowish text-black px-6 py-2 rounded-md font-semibold hover:bg-yellow-400"
>
  Add Selected
</button>

  </div>
)}
          <div className="flex space-x-3 items-center">
            <button
              onClick={() => setIsAdding((prev) => !prev)}
              className="bg-yellowish text-black px-4 py-2 rounded-md text-sm font-semibold hover:bg-yellow-400 transition"
            >
              {isAdding ? "Cancel" : "Add New"}
            </button>

            <img className="cursor-pointer" onClick={onClose} src={close} alt="close" />
          </div>

        </div>

        {/* Add Image Section */}
        {isAdding && (
          <div className="px-10 pb-4">
            <input
              type="text"
              placeholder="Image Name"
              value={imageName}
              onChange={(e) => setImageName(e.target.value)}
              className="bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10"
            />

            <UploadControlsV2
              tooltipTitle="Upload Gallery Image"
              className="my-3"
              title="Gallery Image *"
              subtitle="Upload Gallery Image"
              webUploadProgressId="galleryImageUpload"
              handleChangeUrl={(e) => setTempUrl(e.target.value)}
              handleWebFileUpload={(e) =>
                handleGalleryFileInputChange(
                  setTempUrl,
                  "galleryImageUrl",
                  e.target.files[0],
                  null,
                  "galleryImageUpload",
                  false,
                  "gallery_image_error"
                )
              }
              webUploadUrl={tempUrl}
              handleWebPreview={() => {
                if (!tempUrl) return;
                setSelectedImage({ web: { url: tempUrl }, name: imageName });
                setActiveTab("gallery");
              }}
              isFieldRequired={!tempUrl}
              requiredMessage=""
              showMobileUpload={false}
              showTabletUpload={false}
              showWebUpload={true}
            />

            <div className="flex justify-end">
              <button
                onClick={handleSaveImage}
                className="bg-yellowish text-black px-5 py-2 rounded-md font-medium hover:bg-yellow-400 transition"
              >
                Save Image
              </button>
            </div>
          </div>
        )}

        {/* Gallery Grid - Updated to match Image Gallery format */}
        <div className="p-10 max-h-[70vh] overflow-y-auto custom-scroll">
          {loading ? (
            <div className="flex justify-center py-10 text-greyish">Loading...</div>
          ) : formattedGallery.length > 0 ? (
            <div className="flex flex-wrap gap-8 justify-start">
              {formattedGallery
                .filter((img) =>
                  img.name?.toLowerCase().includes(searchText.toLowerCase())
                )
                .map((img) => (
                  <div key={img._id} className="relative group">
                    {/* MAIN IMAGE */}
                    {/* Multi Select Checkbox */}
<div className="absolute top-2 right-2 z-20">
  <input
    type="checkbox"
    checked={multiSelectedImages.some((i) => i.id === img._id)}
    onChange={(e) => {
      e.stopPropagation();
      toggleMultiSelect(img);
    }}
    className="w-4 h-4 accent-yellowish cursor-pointer"
  />
</div>

                    <img
                      src={img.web?.url || "/placeholder.jpg"}
                      alt="Gallery"
                      className="w-[180px] h-[120px] object-cover rounded-lg border border-gray-700 shadow-md cursor-pointer transition-transform duration-300 hover:scale-[1.03]"
                      onClick={() => handleImagePreview(img)}
                    />

                    {/* ====== RESPONSIVE VERSION MINI PREVIEWS ====== */}
                    <div className="absolute -top-8 right-2 flex flex-col gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                      {/* Tablet preview circle */}
                      {img.tablet?.url && (
                        <img
                          src={img.tablet.url}
                          title="Tablet Image"
                          className="w-6 h-6 rounded-full border border-white shadow object-cover cursor-pointer"
                          onClick={(e) => {
                            e.stopPropagation();
                            setSelectedPreviewImage(img);
                            setPreviewTab("tablet");
                            setShowPreviewModal(true);
                          }}
                        />
                      )}
                    </div>

                    {/* Mobile preview circle */}
                    <div className="absolute top-2 -right-8 flex flex-col gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                      {img.mobile?.url && (
                        <img
                          src={img.mobile.url}
                          title="Mobile Image"
                          className="w-6 h-6 rounded-full border border-white shadow object-cover cursor-pointer"
                          onClick={(e) => {
                            e.stopPropagation();
                            setSelectedPreviewImage(img);
                            setPreviewTab("mobile");
                            setShowPreviewModal(true);
                          }}
                        />
                      )}
                    </div>
                    {/* ====== END MINI PREVIEWS ====== */}

                    {/* Title */}
                    <div className="absolute bottom-2 left-1/2 -translate-x-1/2 bg-black/70 text-[10px] px-2 py-0.5 rounded-md text-white truncate max-w-[160px]">
                      {img.name}
                    </div>

                    {/* ✅ Default Checkbox for this image */}
                    <div className="absolute top-2 left-2 flex items-center gap-1 bg-black/50 p-1 rounded-md z-10">
                      <input
                        type="checkbox"
                        id={`default-${img._id}`}
                        checked={imageDefaultStates[img._id] || false}
                        onChange={(e) => handleDefaultChange(img._id, e.target.checked)}
                        className="w-3 h-3 cursor-pointer accent-yellowish"
                      />
                      <label
                        htmlFor={`default-${img._id}`}
                        className="text-white text-[8px] cursor-pointer select-none"
                      >
                        Default
                      </label>
                    </div>

                    {/* ✅ Select Button */}
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        handleGallerySelect({
                          name: img.name,
                          id: img._id,
                          web: img.web,
                          tablet: img.tablet,
                          mobile: img.mobile,
                          mobilesetting: objectFit.mobile,
                          tabletsetting: objectFit.tablet,
                          dashboardsetting: objectFit.desktop,
                          default: imageDefaultStates[img._id] || false, // ✅ Use individual image's default state
                          raw: img.raw,
                        });
                        onClose();
                      }}
                      className="absolute bottom-2 right-2 bg-yellowish/80 hover:bg-yellowish text-black text-[10px] px-2 py-1 rounded-md font-semibold transition z-10"
                    >
                      Select
                    </button>
                  </div>
                ))}
            </div>
          ) : (
            <p className="text-greyish text-center py-10">No images found in gallery.</p>
          )}
        </div>
      </div>

      {/* ✅ Preview Modal with Tabs - Auto-resizing */}
      {selectedPreviewImage && showPreviewModal && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-[100] px-4">
          <div
            className="bg-gray-900 p-6 rounded-lg max-h-[90vh] overflow-auto relative"
            style={{
              width: "auto",
              maxWidth: "90vw",
              minWidth: "300px" // Minimum width for modal
            }}
          >
            {/* Close Button - Only one at top-right */}
            <button
              className="absolute top-4 right-4 bg-black/60 p-2 rounded-full hover:bg-black transition z-50"
              onClick={closePreviewModal}
            >
              <AiOutlineClose className="text-white w-5 h-5" />
            </button>

            {/* Image Name */}
            <div className="text-center mb-4">
              <h3 className="text-lg font-semibold text-white">{selectedPreviewImage.name}</h3>
            </div>

            {/* Tabs for Desktop/Mobile */}
            <div className="flex justify-center mb-6 gap-3">
              {["desktop", "tablet", "mobile"].map((tab) => (
                <button
                  key={tab}
                  onClick={() => setPreviewTab(tab)}
                  className={`px-4 py-2 rounded-md text-sm ${
                    previewTab === tab
                      ? "bg-yellowish text-black font-semibold"
                      : "bg-gray-700 text-white"
                  }`}
                >
                  {tab.charAt(0).toUpperCase() + tab.slice(1)} View
                </button>
              ))}
            </div>

            {/* Image Preview - Auto-sizing container */}
            <div className="flex justify-center mb-6">
              <div
                className="relative bg-black rounded-md overflow-hidden border border-gray-600"
                style={{
                  width: "auto",
                  maxWidth: getModalWidth(),
                  maxHeight: "70vh"
                }}
              >
                <img
                  ref={previewImgRef}
                  src={getPreviewImageUrl()}
                  alt={selectedPreviewImage.name}
                  className="max-w-full max-h-[65vh] object-contain"
                  onLoad={handleImageLoad}
                  style={{
                    width: "auto",
                    height: "auto",
                    display: "block",
                    margin: "0 auto"
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ✅ Settings Modal for selected image (when clicking from Add New section) - Auto-resizing */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black/70 flex items-center justify-center z-[10000]"
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              setSelectedImage(null);
            }
          }}
        >
          <div
            className="bg-gray-900 p-6 rounded-lg max-h-[90vh] overflow-auto relative"
            style={{
              width: "auto",
              maxWidth: "90vw",
              minWidth: "300px"
            }}
          >
            {/* Close Button */}
            <button
              className="absolute top-4 right-4 bg-black/60 p-2 rounded-full hover:bg-black transition z-50"
              onClick={() => setSelectedImage(null)}
            >
              <AiOutlineClose className="text-white w-5 h-5" />
            </button>

            {/* Tabs */}
            <div className="flex justify-center mb-4 gap-3">
              {["desktop", "tablet", "mobile"].map((tab) => (
                <button
                  key={tab}
                  onClick={() => setActiveTab(tab)}
                  className={`px-4 py-2 rounded-md text-sm ${
                    activeTab === tab
                      ? "bg-yellowish text-black font-semibold"
                      : "bg-gray-700 text-white"
                  }`}
                >
                  {tab.charAt(0).toUpperCase() + tab.slice(1)} View
                </button>
              ))}
            </div>

            {/* Object Fit Buttons */}
            <div className="flex justify-center mb-4 gap-2">
              {["cover", "contain", "fill", "none", "scale-down"].map((fit) => (
                <button
                  key={fit}
                  onClick={() =>
                    setObjectFit((prev) => ({ ...prev, [activeTab]: fit }))
                  }
                  className={`px-3 py-1 text-xs rounded-md ${
                    objectFit[activeTab] === fit
                      ? "bg-yellowish text-black"
                      : "bg-gray-700 text-white"
                  }`}
                >
                  {fit}
                </button>
              ))}
            </div>

            {/* Preview - Auto-sizing */}
            <div className="relative flex justify-center mb-6">
              <div style={{ width: "auto", maxWidth: "800px" }}>
                {activeTab === "desktop" && (
                  <div className="w-auto max-w-full border border-gray-700 rounded-md overflow-hidden">
                    <img
                      src={selectedImage?.web?.url || ""}
                      alt={selectedImage?.name}
                      className="w-auto max-w-full h-auto max-h-[50vh] object-contain"
                    />
                  </div>
                )}
                {activeTab === "tablet" && (
                  <div className="w-auto max-w-[600px] border border-gray-700 rounded-md overflow-hidden">
                    <img
                      src={selectedImage?.tablet?.url || selectedImage?.web?.url || ""}
                      alt={selectedImage?.name}
                      className="w-auto max-w-full h-auto max-h-[50vh] object-contain"
                    />
                  </div>
                )}
                {activeTab === "mobile" && (
                  <div className="w-auto max-w-[400px] border border-gray-700 rounded-md overflow-hidden">
                    <img
                      src={selectedImage?.mobile?.url || selectedImage?.web?.url || ""}
                      alt={selectedImage?.name}
                      className="w-auto max-w-full h-auto max-h-[50vh] object-contain"
                    />
                  </div>
                )}
              </div>
            </div>

            {/* Submit Button */}
            <div className="flex justify-center">
              <button
                onClick={() => {
                  if (selectedImage) {
                    handleGallerySelect({
                      name: selectedImage.name,
                      id: selectedImage._id,
                      web: selectedImage.web,
                      tablet: selectedImage.web,
                      mobile: selectedImage.web,
                      mobilesetting: objectFit.mobile,
                      tabletsetting: objectFit.tablet,
                      dashboardsetting: objectFit.desktop,
                      default: false,
                    });
                    setSelectedImage(null);
                    onClose();
                  }
                }}
                className="bg-yellowish text-black px-5 py-2 rounded-md font-medium hover:bg-yellow-400 transition"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}


    </div>,
    document.getElementById("modal-root")
  );
};

export default GalleryLibraryModal;
